import { runAfterBootstrap } from 'owa-delayed-initialization';
import { initSpamOption, SpamScenarioId } from 'owa-spam-row-option';
export { default as SafeSendersDomainsOptionV2 } from './SafeSendersDomainsOptionV2';

runAfterBootstrap(() => {
    initSpamOption(SpamScenarioId.SafeSendersAndDomains);
});
